<app-scaffold
  icon="streamline:hyperlink-3"
  [title]="'ERROR.INVALID_LINK.TITLE' | translate"
  [content]="'ERROR.INVALID_LINK.CONTENT' | translate"
>
</app-scaffold>
